import * as React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    // FormControl,
    FormControlLabel,
    IconButton,
    // DialogTitle,
    Slide,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { EditMode } from '../../Types';

const styles = makeStyles((theme) => ({
    paper: {
        backgroundColor: '#0e0c10ad',
        borderRadius: '5px',
        maxWidth: '400px',
        padding: '16px',
        boxSizing: 'border-box',
    },
    contentText: {
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: '24px',
        lineHeight: '48px',
        color: '#EDE8E8',
        textTransform: 'uppercase' as 'uppercase',
        textAlign: 'center',
        marginBottom: '18px',
    },
    buttonContainer: {
        display: 'block',
        padding: '0px',
    },
    button: {
        color: theme.palette.common.white,
        marginBottom: '10px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        width: '50%',
        fontSize: '14px',
        fontFamily: 'Poppins',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    checkboxContaner: {
        alignSelf: 'flex-end',
        margin: '0px',
        padding: '0px',
        color: '#CAC5C5',
        marginTop: '12px',
    },
    cardHeaderCss: {
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        marginBottom: '12px',
    },
    actionFooterCss: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '16px',
    },
}));

interface IProps {
    editMode: EditMode;
    localStorageKey: string;
    chromeKeyDialogState: boolean;
    closeAt: number;
}

const Transition = React.forwardRef(
    (
        props: TransitionProps & { children?: React.ReactElement<any, any> },
        ref: React.Ref<unknown>
    ) => <Slide direction='up' ref={ref} {...props} timeout={800} />
);

export function ScheduleDemoDialog({
    editMode,
    localStorageKey,
    chromeKeyDialogState,
    closeAt,
}: IProps) {
    const intervalId = React.useRef<NodeJS.Timeout | null>(null);
    const [open, setOpen] = useState(false);
    const [timerTicker, setTimeTicker] = useState(0);
    const classes = styles();
    const doNotShowPrompt = localStorage.getItem(localStorageKey) === 'true';
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.checked) {
            localStorage.setItem(localStorageKey, 'true');
        } else {
            localStorage.removeItem(localStorageKey);
        }
    }

    const handleScheduleDemo = () => {
        const calendlyMeet =
            (process.env.CALENDLY_MEET_LINK as string) ||
            'http://calendly.com/forpeoplewhojustwanttocoach/30min';
        window.open(calendlyMeet, '_blank');
    };

    React.useEffect(() => {
        const diff = new Date().getTime() - closeAt;

        if (diff > 30000 && closeAt > 0) {
            setOpen(true);
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        } else {
            setOpen(false);
        }
    }, [closeAt, editMode, timerTicker]);

    React.useEffect(() => {
        if (closeAt > 0 && !doNotShowPrompt) {
            intervalId.current = setInterval(() => {
                setTimeTicker((prev) => prev + 1);
            }, 1000);
        }
        return () => {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        };
    }, [closeAt]);

    return !doNotShowPrompt ? (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setOpen((prev: boolean) => !prev)}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
            classes={{ paper: classes.paper }}
        >
            <DialogContent style={{ padding: '0px' }}>
                <div className={classes.cardHeaderCss}>
                    <IconButton
                        aria-label='Close modal'
                        component='span'
                        onClick={() => setOpen((prev: boolean) => !prev)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContentText
                    id='alert-dialog-slide-description'
                    className={classes.contentText}
                >
                    Schedule a free demo with an expert
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.buttonContainer}>
                <div>
                    <FormControlLabel
                        className={classes.checkboxContaner}
                        control={
                            <Checkbox
                                onChange={handleChange}
                                style={{ color: '#7FF0E3' }}
                            />
                        }
                        label='Don’t show this message again'
                    />
                </div>
                <div className={classes.actionFooterCss}>
                    <Button
                        onClick={handleScheduleDemo}
                        className={classes.button}
                    >
                        Schedule a meet
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    ) : (
        <></>
    );
}



// WEBPACK FOOTER //
// ./src/Features/TelestrationsVideoLibrary/Components/TelestrationControls/ScheduleDemoDialog.tsx